<div class="pwa-banner">
  <div class="pwa-banner__logo-wrapper">
    <div class="pwa-banner__logo-wrapper__logo">
      <ui-svg-icon
        [iconClassName]="'icon-pwa-banner--nursing'"
        [svgId]="'nursing'"
      ></ui-svg-icon>
    </div>
  </div>
  <div class="pwa-banner__content">
    <div class="pwa-banner__content__header-row">
      <h1>Save the app on your homescreen!</h1>
      <div class="pwa-banner__content__header-row__close">
        <ui-svg-icon
          (click)="onClose($event)"
          (keydown)="onClose($event)"
          iconClassName="preview-modal--close"
          svgId="close"
          tabindex="0"
        ></ui-svg-icon>
      </div>
    </div>
    <p>Download the app today and manage your application on the go.</p>
    <ui-button
      (handleClick)="onDownload($event)"
      buttonClassName="button-full-width"
      buttonId="pwa-banner-pwa-install"
      buttonText="Download Here"
      gtmTag="pwa-banner-pwa-install"
    ></ui-button>
  </div>
</div>
